import { apiClient, ApiResponse } from './api'

export interface Role {
  _id: string
  name: string
  description: string
  permissions: string[]
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  deletedAt: string | null
  deletedBy: string | null
  __v: number
}

export interface CreateRoleRequest {
  name: string
  description: string
  permissions: string[]
}

export interface UpdateRoleRequest {
  description?: string
  permissions?: string[]
}

export const rolesApi = {
  /**
   * Get all roles
   */
  async getRoles(): Promise<ApiResponse<Role[]>> {
    try {
      const response = await apiClient.get<Role[]>('/auth-service/api/v1/roles', undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Get roles error:', error)
      throw error
    }
  },

  /**
   * Get role by ID
   */
  async getRoleById(roleId: string): Promise<ApiResponse<Role>> {
    try {
      const response = await apiClient.get<Role>(`/auth-service/api/v1/roles/${roleId}`, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Get role by ID error:', error)
      throw error
    }
  },

  /**
   * Create a new role
   */
  async createRole(roleData: CreateRoleRequest): Promise<ApiResponse<Role>> {
    try {
      const response = await apiClient.post<Role>('/auth-service/api/v1/roles', roleData, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Create role error:', error)
      throw error
    }
  },

  /**
   * Update role
   */
  async updateRole(roleId: string, roleData: UpdateRoleRequest): Promise<ApiResponse<Role>> {
    try {
      const response = await apiClient.patch<Role>(`/auth-service/api/v1/roles/${roleId}`, roleData, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Update role error:', error)
      throw error
    }
  },

  /**
   * Delete role
   */
  async deleteRole(roleId: string): Promise<ApiResponse<{ success: boolean; message: string }>> {
    try {
      const response = await apiClient.delete<{ success: boolean; message: string }>(`/auth-service/api/v1/roles/${roleId}`, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Delete role error:', error)
      throw error
    }
  }
}
